import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import PageLayout from "examples/LayoutContainers/PageLayout";
import boxShadow from "assets/theme/functions/boxShadow";
import { useSelector } from "react-redux";
  import useMediaQuery from "@mui/material/useMediaQuery";

function CoverLayout({ color, header, title, description, image, top, children,forgot }) {

  const matches = useMediaQuery("(max-width:600px)");
  const userTheme = useSelector((state) => state.commonSlice.theme);

  return (
    <PageLayout >

      <Grid
        container
        justifyContent="center"
        sx={{
          minHeight: "75vh",
          margin: 0,
        }}
      >
        <Grid item xs={11} sm={8} md={5} xl={3}>
          <SoftBox className="glassmorphism-card" mt={matches?10:top}>
            <SoftBox pt={3} px={3}>
              {!header ? (
                <>
                  <SoftBox mb={1}>
                    <SoftTypography variant="h3" fontWeight="bold" color={color} textGradient>
                      {title}
                    </SoftTypography>
                  </SoftBox>
                  <SoftTypography variant="body2" fontWeight="regular" color="text">
                    {description}
                  </SoftTypography>
                </>
              ) : (
                header
              )}
            </SoftBox>
            <SoftBox p={3}>{children}</SoftBox>
          </SoftBox>
        </Grid>
        <Grid item xs={12} md={5}>
          {/* <SoftBox
            height="100%"
            display={{ xs: "none", md: "block" }}
            position="relative"
            right={{ md: "-12rem", xl: "-16rem" }}
            mr={-16}
            sx={{
              transform: "skewX(-10deg)",
              overflow: "hidden",
              borderBottomLeftRadius: ({ borders: { borderRadius } }) => borderRadius.lg,
            }}
          > */}
          {/* <SoftBox
              mr={-25}
              ml={8}
              mt={26}
              height="60%"
              sx={{
                backgroundImage: `url(${image})`,
                backgroundSize: "contain",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",  
                boxShadow:"0 0 20px 0 rgba(0, 0, 0, 0.1)",
                borderRadius:"20px",
                backgroundColor:"none"
              }}
            /> */}
          {/* <SoftBox
             
            ml={12}
            mt={26}

            sx={{
              width: "100%",
              backgroundColor: userTheme == 'dark' ? "rgb(255, 255, 255)" : "none",
            }}
           
          > */}
            <img
              src={image}
              alt="cover"
              // width={matches?500:700}
              // height={matches?300:forgot?650:400}
              style={{
              width: matches ? "100%" : "auto",
              height: matches ? "auto" : forgot ? "650px" : "400px",
              borderRadius: "20px",
              boxShadow: !forgot? userTheme == 'dark' ? "rgb(255, 255, 255) 0px 0px 50px" : "0 0 20px 0 rgba(0, 0, 0, 0.1)":"none",
              borderRadius: "20px",
              padding: matches?"1rem": "0rem",
              marginLeft: matches?"0rem": "6rem",
              marginTop: matches?"3rem": forgot?"2rem":"12rem",
              backgroundColor:"none"
              }}
              
            />

          {/* </SoftBox> */}


          {/* </SoftBox> */}
        </Grid>
      </Grid>
      {/* <Footer /> */}
    </PageLayout>
  );
}

// Setting default values for the props of CoverLayout
CoverLayout.defaultProps = {
  header: "",
  title: "",
  description: "",
  color: "info",
  top: 20,
};

// Typechecking props for the CoverLayout
CoverLayout.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
    "light",
  ]),
  header: PropTypes.node,
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string.isRequired,
  top: PropTypes.number,
  children: PropTypes.node.isRequired,
};

export default CoverLayout;

// <DefaultNavbar
// action={{
//   type: "external",
//   route: "https://creative-tim.com/product/soft-ui-dashboard-react",
//   label: "free download",
//   color: "dark",
// }}
// />
